<template>
    <div class="list">
        <NavBar></NavBar>
        <div v-if="isShow" style="margin-top:60px">
            <van-empty image="error" description="您已绑定过该房间！" />
        </div>
        <div v-if="!isShow" class="contentInclude">
            <van-col span="24" style="font-size:14px;font-weight:bold">{{HouseObj.houseSite}}</van-col>
            <van-col span='24' style="font-size:12px;color:gray;margin:10px 0 20px 0">房屋交易业务编号:{{HouseObj.houseSeqNo}}</van-col>
            <van-row type="flex"  justify="space-between">
                <van-col span="6" style="text-align:center">
                    <div style="font-weight:bold;margin-bottom:7px">{{HouseObj.struArea}}</div>
                    <div style="font-size:12px;color:gray">建筑面积(㎡)</div>
                </van-col>
                <van-col span="7" style="text-align:center">
                    <div style="font-weight:bold;margin-bottom:7px">{{HouseObj.ratio}}</div>
                    <div style="font-size:12px;color:gray">交存标准(元/㎡)</div>
                </van-col>
                <van-col span="6" style="text-align:center">
                    <div style="font-weight:bold;margin-bottom:7px;color: rgb(89, 195, 236);">{{HouseObj.amountDue}}</div>
                    <div style="font-size:12px;color:gray">应交金额(元)</div>
                </van-col>
            </van-row>
        </div>
        <!-- <van-row v-if="!isShow" type="flex" justify="center" class="house_list">
            <van-list>
                <div class="card1" v-for="item in list" :key="item">
                    <van-row class="house_site"><van-col span="24">{{item.a}}</van-col></van-row>
                    <van-row class="house_no"><van-col span="24">房屋交易业务编号：{{item.b}}</van-col></van-row>
                    <van-row>
                        <van-col span="8" class="content_left">
                            <van-col span="24" class="house_money">{{item.f}}</van-col>
                            <van-col span="24">建筑面积(㎡)</van-col>
                        </van-col>
                        <van-col span="8" class="content_left">
                            <van-col span="24" class="house_money">{{item.e}}</van-col>
                            <van-col span="24">交存状态</van-col>
                        </van-col>
                        <van-col span="8" class="content_left">
                            <van-col span="24" class="house_money" style="color:skyblue">{{item.d}}</van-col>
                            <van-col span="24">应交金额(元)</van-col>
                        </van-col>
                    </van-row>
                </div>
            </van-list>
        </van-row> -->
         <div class="flex">
            <van-col span="24" class="house_button">
                <van-button type="danger" size="normal" :disabled='isShow' @click="ImmedBinding">立即绑定</van-button>
            </van-col>
        </div>
    </div>
</template>

<script>
import VueCookie from 'vue-cookie'
export default {
    data(){
        return {
            isShow:false,
            contractNo:'',
            loading:false,
            finished:false,
            obj:{},
            HouseObj:{}
        }
    },
    methods:{
       /**
        * 列表
        */
       HouseList(){
           let data = {
               openId:VueCookie.get('openid'),
               contractNo:this.contractNo,
            //    openId:'o5AgcxDoREhPpdd0wzkSYvfnSKmQ',
           }
           this.$postQuery('/WeChat/getBindHouse', data).then((response)=>{
                if(response.data.data==200){
                    this.obj = response.data.obj
                }else{
                    this.isShow = true
                }
           })
       },
       /**
        * 立即绑定
        */
       ImmedBinding(){
            let data = {
                // openId:'o5AgcxDoREhPpdd0wzkSYvfnSKmQ',
                openId:VueCookie.get('openid'),
                contractNo:this.contractNo,
                houseSeqNo:this.HouseObj.houseSeqNo,
                houseId:this.HouseObj.houseId,
            }
            this.$postQuery('/WeChat/bindHouse', data).then((response)=>{
                if(response.data.data==200){
                    this.$toast('绑定成功!')
                    this.$router.push({
                        path:'/HousingManagement'
                    })
                }else{
                    this.$toast('绑定失败!')
                }
            })
       },
    },
    created(){
        this.HouseObj =  JSON.parse(this.$route.query.obj)
        console.log(this.HouseObj)
        this.contractNo=this.$route.query.contractNo
        console.log(this.contractNo,'2222222222222')
        // this.HouseList()
    }
}
</script>

<style scoped>
.list{
    margin-top: 46px;
}
.house_list .card1{
  padding: 5px 20px;
  font-size: 12px;
  margin: 0 auto;
  box-shadow: 0 8px 12px #ebedf0;
  margin-top: 8px;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
}
.house_list .van-col{
  margin-top:10px;
  margin-bottom:10px;
}
.house_list{
  overflow: auto;
}
.house_site,.house_area,.house_money{
  font-size: 14px;
  font-weight: bold;
}
.content_left,.content_right{
  margin: 0 !important;
  text-align: center;
}
.flex {
 position: fixed;
 bottom: 0;
 left: 0;
 width: 100%;
}
.flex .house_button{
    margin: 10px;
}
.flex .house_button .van-button,.content_button .van-button{
    padding: 3px 15px;
    width: 100%;
}
.contentInclude {
    border: 1px solid rgb(238, 236, 236);
    padding: 14px 10px;
    margin: 20px 6px;
    border-radius: 5px;
    box-shadow: 2px 3px 12px #ebedf0;
}
</style>